<template>

    <div class="container">

        <app-head title="Tokens" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Tokens') }}</h1>
            <div class="">
                <inertia-link :href="route('admin.tokens.create', {})" as="button" method="post" class="btn btn-primary">
                    {{ __('Erstellen') }}
                </inertia-link>
            </div>
        </div>

        <div class="card mb-4">
            <div class="table-responsive">
                <table class="table">
                    <thead class="">
                        <tr>
                            <th>{{ __('Name') }}</th>
                            <th>{{ __('Created') }}</th>
                            <th>{{ __('Last used') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="tokens.length === 0">
                            <td colspan="5">
                                {{ __('Noch keine Tokens erzeugt') }}
                            </td>
                        </tr>
                        <template v-else>
                            <tr v-for="token in tokens" :key="token.id">
                                <td>{{ token.name }}</td>
                                <td>{{ token.created_at | localizeDateTime }}</td>
                                <td>{{ token.last_used_at || '-' }}</td>
                                <td class="text-end">
                                    <inertia-link :href="route('admin.tokens.revoke', token.id)" as="button" method="post" class="btn btn-outline-danger">
                                        {{ __('Widerrufen') }}
                                    </inertia-link>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

</template>

<script>


    export default {

        props: {
            tokens: Array
        },
    }
</script>